
export default class Utils{

    public static tweetText2Html (__tweet:any) :string{

        let text = __tweet.full_text.replace(/\n/g, '<br/>');
        let hashtags = __tweet.entities.hashtags;
        let user_mentions = __tweet.entities.user_mentions;
        let urls = __tweet.entities.urls;

        for(let i=0; i < hashtags.length; i++) {
            let replaceText = '<a href="https://twitter.com/hashtag/' + hashtags[i].text + '" target="_blank">#' + hashtags[i].text + '</a>';
            text = text.replace('#' + hashtags[i].text, replaceText);
        }

        for(let i=0; i < user_mentions.length; i++) {
            let replaceText = '<a href="https://twitter.com/' + user_mentions[i].screen_name + '" target="_blank">@' + user_mentions[i].screen_name + '</a>';
            text = text.replace('@' + user_mentions[i].screen_name, replaceText);
        }

        for(let i=0; i < urls.length; i++) {
            let displayUrl:string = "";
            if(urls[i].expanded_url.indexOf("https://fuzkue.com/fuzkuehour?no=") >= 0){
                displayUrl = "fuzkue.com/fuzkuehour"
            }else{
                displayUrl = urls[i].display_url
            }
            let replaceText = '<a href="' + urls[i].expanded_url + '" target="_blank">' + displayUrl + '</a>';
            text = text.replace(urls[i].url, replaceText);
        }

        if(__tweet.entities.media) {
            let media = __tweet.entities.media;

            for(let j=0; j < media.length; j++) {
                text = text.replace(media[j].url, "");
            }
        }

        return text;
    }

}

